import React from 'react';
import styled from 'styled-components';
//
import HoverImage from 'components/hover-image';
import LinkToIf from 'components/link-to-if';
// import { VideoEmbed } from 'components/prismic';
//
export default ({
  content,
  handleClick,
  hoverImage,
  image,
  mediaWidth,
  videoUrl,
  weblink,
  withDescription,
  descriptionLeft,
}) => {
  let path = content && content.id && content.path;

  let onClick = handleClick;

  if (weblink) {
    path = weblink;
    onClick = false;
  }

  return (
    <Wrap
      descriptionLeft={descriptionLeft}
      withDescription={withDescription}
      mediaWidth={mediaWidth}
    >
      <LinkToIf
        to={path}
        title={content && content.title}
        onClick={(e) => (onClick ? onClick(e, content) : true)}
      >
        <HoverImage image={image} hoverImage={hoverImage} videoUrl={videoUrl} />
      </LinkToIf>
      {withDescription && (
        <DescriptionArrow descriptionLeft={descriptionLeft} />
      )}
    </Wrap>
  );
};
//
const Wrap = styled.div`
  bottom: 0;
  left: ${({ descriptionLeft }) => (descriptionLeft ? 'auto' : 0)};
  position: absolute;
  right: ${({ descriptionLeft }) => (descriptionLeft ? 0 : 'auto')};
  top: 0;
  width: ${({ mediaWidth, withDescription }) =>
    withDescription
      ? `calc(${(mediaWidth / (mediaWidth + 1)) * 100}% - .3vw)`
      : '100%'};

  > a {
    bottom: 0;
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

const DescriptionArrow = styled.div`
  border-bottom: 0.5vw solid transparent;
  border-right: 0.5vw solid currentColor;
  border-top: 0.5vw solid transparent;
  height: 0;
  left: ${({ descriptionLeft }) => (descriptionLeft ? 0 : 'auto')};
  position: absolute;
  right: ${({ descriptionLeft }) => (descriptionLeft ? 'auto' : 0)};
  top: 0.125vw;
  transform: ${({ descriptionLeft }) =>
    descriptionLeft ? 'translateX(-150%) rotate(180deg)' : 'translateX(150%)'};
  width: 0;
  z-index: 20;
`;
